<div class="profile-popup-overlay" *ngIf="show" (click)="onClose()">
  <div class="profile-popup" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h2>Profile</h2>
      <button class="close-btn" (click)="onClose()">×</button>
    </div>

    <div class="popup-content">
      <div class="section basic-details">
        <h3>Basic Details</h3>
        <div class="detail-row" *ngIf="userDetails?.fullName">
          <label>Name:</label>
          <span>{{ userDetails?.fullName }}</span>
        </div>
        <div class="detail-row">
          <label>Email:</label>
          <span>{{ userDetails?.email }}</span>
        </div>
        <div class="detail-row">
          <label>Role:</label>
          <span>{{ userDetails?.role }}</span>
        </div>
        <div class="detail-row">
          <label>Member Since:</label>
          <span>{{ userDetails?.memberSince }}</span>
        </div>
      </div>
    </div>
  </div>
</div>